import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, } from '@angular/core';

import { MysqlService } from './../../../services/mysql.service';
import { Trace } from './../../../api/trace';
import {DemoService} from '../../../demo.service';
import {DatePipe, Location} from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { HotToastService } from '@ngneat/hot-toast';

@Component({
  selector: 'app-user-view',
  templateUrl: './user-view.component.html',
  styleUrls: ['./user-view.component.css']
})
export class UserViewComponent implements OnInit {
  nav: any;
  body: HTMLBodyElement;
  user_id: number;
  brand_id: any;
  brandMysql: any;
  users: any;

  public baseUploadURL = this.gfunc.baseUploadURL_UserAssets; // no trailing slash
  user_level: any;
  access_level: any;
  baseBrandUploadURL: string;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  modalRef: any;
  log_name: string;
  log_data: any;

  constructor(   private _mysqlService: MysqlService, private route: ActivatedRoute, private router: Router,
    public _demoService: DemoService,private _location: Location,
    public gfunc: GlobalFunctionsService,
     private fileUploader: FileUploaderService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public toastr: HotToastService,
  
    ) {
      this.nav = document.querySelector('nav.navbar');
      this.body = document.querySelector('body');
      this.user_id = +this.route.snapshot.paramMap.get('user_id');
      // Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


     }

  ngOnInit() {
    this.baseUploadURL = this.gfunc.baseUploadURL_UserAssets + '/' + this.user_id; // no trailing
    this.getUserById(this.user_id);
  }

  getUserById(user_id) {

    this._demoService.getUsersById(user_id).subscribe(
       data => { this.users = data;
        this.brand_id = this.users.map(function(a) {return a ['brand_id']; });
        this.access_level = this.users.map(function(a) {return a ['access_level']; });
        this.getBrandMysql(this.brand_id);
        this.getFormUserLevel(this.access_level);
        this.baseBrandUploadURL = this.gfunc.baseUploadURL_BrandAssets + '/' + this.brand_id; // no trailing
        // console.log(JSON.stringify(this.users));

      
      },
       err => console.error(err),
       () => console.log('Candidates Loaded.')
     );
}


private getBrandMysql(brand_id) {
  this._mysqlService.getMysqlBrandDatas(brand_id)
    .subscribe(
      res => this.brandMysql = res,
      err => console.error(err.status)
    );
}


getFormUserLevel(level) {
  this._demoService.getUserLevel(level).subscribe(
     data => { this.user_level = data;
      console.log(data);
   },
     err => console.error(err),
     () => console.log('done loading User Levels')
   );
 }

   // to router navigate back
   public goBack() {
    this._location.back();
  }
  
  
  userView(user_id) {
    // this.router.navigate(['/admin/brands/users/view/' + user_id + '']);
    this.gfunc.globalUserView(user_id);
  }
  
  userEdit(user_id) {
    // this.router.navigate(['/admin/brands/users/edit/' + user_id + '']);
    this.gfunc.globalUserEdit(user_id);
  }




   // MODAL
  // start of modal windows service as a template
  openModal(template: TemplateRef<any>) {
    // small upgrade to disable background click on open modal background
    const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
    this.modalRef = this.modalService.show(template, config);
  }
  
  // :: Parent / Child modal test
  closeParentModel() {
    // alert('parent component function.');
    this.modalRef.hide();
    this.getUserById(this.user_id);
   // this.refreshGrid(); // resets the grid if updated and closed.
  //  this.updateTypeClick = false; // closes the div
  };




// update was here for onit but moved for onchange
setUserForceLogout(model, user_id, force_logout)  {

  this._demoService.setUserForceLogout(model, user_id, force_logout) .subscribe(
     data => {
      // console.log(model);
       // this.trace_candidate_update = data;
     this.toastr.success('User FLO Status Updated');

     if(force_logout == 1){
      this.log_name = 'FLO, User Forced To Logout MODE ON: ' + model.user_id + ' USER :: '
      + ' - ' + model.username + ' (' + model.first_name + ' ' + model.surname + ' ' + model.email_address +  ' ) ';

              // insert log
        this.log_data = {
                // log_id: null,
                log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                log_action: 'forced_logout_ON', // automated / updated / created / uploaded / link_created / sent / accessed
                log_type_id: 28, // see datatable system_log_types (12 = subject_attempt)
                // created_by: this.sessionUserId,
                created_by: model.user_id,
                created_date: this.gfunc.today,
                subject_id: model.file_subject_id,
                job_id: model.file_job_id,
                job_reference_number: model.job_reference_number,
                file_number: model.file_number,
                reference_number: model.reference_number,
                subject_number: model.file_subject_number,
                brand_id: model.brand_id,
                user_id: model.user_id,
            
                created_level: model.created_level, // staff
                brand_type_id: model.brand_type_id,
                subject_com_type_id: model.subject_com_type_id,
                subject_template_doc_id: model.subject_template_doc_id,
                log_name: this.log_name,
              file_id: model.file_id,
              agent_id: null,
              invoice_id: null,
              };



     }else{
      this.log_name = 'FLO, User Forced MODE OFF  ' + model.user_id + ' USER :: '
      + ' - ' + model.username + ' (' + model.first_name + ' ' + model.surname + ' ' + model.email_address +  ' ) ';

          // insert log
          this.log_data = {
            // log_id: null,
            log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
            log_action: 'forced_logout_OFF', // automated / updated / created / uploaded / link_created / sent / accessed
            log_type_id: 29, // see datatable system_log_types (12 = subject_attempt)
            // created_by: this.sessionUserId,
            created_by: model.user_id,
            created_date: this.gfunc.today,
            subject_id: model.file_subject_id,
            job_id: model.file_job_id,
            job_reference_number: model.job_reference_number,
            file_number: model.file_number,
            reference_number: model.reference_number,
            subject_number: model.file_subject_number,
            brand_id: model.brand_id,
            user_id: model.user_id,
        
            created_level: model.created_level, // staff
            brand_type_id: model.brand_type_id,
            subject_com_type_id: model.subject_com_type_id,
            subject_template_doc_id: model.subject_template_doc_id,
            log_name: this.log_name,
          file_id: model.file_id,
          agent_id: null,
          invoice_id: null,
          };


     }


   this.gfunc.createSystemLog(this.log_data);


     this.getUserById(this.user_id);
     // Subject to reload the manager component parent.
    // BrandUserManagerComponent.returned.next(false);
       return true;
     },
     error => {
       console.error('Error saving User!');
       this.getUserById(this.user_id);
      return console.log(error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
  );
  }
 






// AUTOMATED TO LOG THE USER OUT ONCE AND THEN ALLOW ACCESS AGAIN
  setUserForceLogoutSoft(model, user_id, force_logout_soft)  {

    this._demoService.setUserForceLogoutSoft(model, user_id, force_logout_soft) .subscribe(
       data => {
        // console.log(model);
         // this.trace_candidate_update = data;
       this.toastr.success('User FLO Status Updated');
  
       if(force_logout_soft == 1){
        this.log_name = 'FLO, User Forced To Logout SOFT MODE ON: ' + model.user_id + ' USER :: '
        + ' - ' + model.username + ' (' + model.first_name + ' ' + model.surname + ' ' + model.email_address +  ' ) ';
  
                // insert log
          this.log_data = {
                  // log_id: null,
                  log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                  log_action: 'forced_logout_ON', // automated / updated / created / uploaded / link_created / sent / accessed
                  log_type_id: 28, // see datatable system_log_types (12 = subject_attempt)
                  // created_by: this.sessionUserId,
                  created_by: model.user_id,
                  created_date: this.gfunc.today,
                  subject_id: model.file_subject_id,
                  job_id: model.file_job_id,
                  job_reference_number: model.job_reference_number,
                  file_number: model.file_number,
                  reference_number: model.reference_number,
                  subject_number: model.file_subject_number,
                  brand_id: model.brand_id,
                  user_id: model.user_id,
              
                  created_level: model.created_level, // staff
                  brand_type_id: model.brand_type_id,
                  subject_com_type_id: model.subject_com_type_id,
                  subject_template_doc_id: model.subject_template_doc_id,
                  log_name: this.log_name,
                file_id: model.file_id,
                agent_id: null,
                invoice_id: null,
                };
  
  
  
       }else{
        this.log_name = 'FLO, User Soft Forced MODE OFF  ' + model.user_id + ' USER :: '
        + ' - ' + model.username + ' (' + model.first_name + ' ' + model.surname + ' ' + model.email_address +  ' ) ';
  
            // insert log
            this.log_data = {
              // log_id: null,
              log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
              log_action: 'forced_logout_soft_OFF', // automated / updated / created / uploaded / link_created / sent / accessed
              log_type_id: 29, // see datatable system_log_types (12 = subject_attempt)
              // created_by: this.sessionUserId,
              created_by: model.user_id,
              created_date: this.gfunc.today,
              subject_id: model.file_subject_id,
              job_id: model.file_job_id,
              job_reference_number: model.job_reference_number,
              file_number: model.file_number,
              reference_number: model.reference_number,
              subject_number: model.file_subject_number,
              brand_id: model.brand_id,
              user_id: model.user_id,
          
              created_level: model.created_level, // staff
              brand_type_id: model.brand_type_id,
              subject_com_type_id: model.subject_com_type_id,
              subject_template_doc_id: model.subject_template_doc_id,
              log_name: this.log_name,
            file_id: model.file_id,
            agent_id: null,
            invoice_id: null,
            };
  
  
       }
  
  
     this.gfunc.createSystemLog(this.log_data);
  
  
       this.getUserById(this.user_id);
       // Subject to reload the manager component parent.
      // BrandUserManagerComponent.returned.next(false);
         return true;
       },
       error => {
         console.error('Error saving User!');
        // this.getUserById(this.user_id);
        return console.log(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
    );
    }






// update was here for onit but moved for onchange
setUserForceLogoutGlobal(model, user_id, force_logout)  {
  if (confirm('Are you sure you want to FLO Hard ALL USERS? ')) {
  this._demoService.setUserForceLogoutGlobal(model, user_id, force_logout) .subscribe(
     data => {
      // console.log(model);
       // this.trace_candidate_update = data;
     this.toastr.success('DONE. ALL Users FLO Status Updated');

                  //    if(force_logout == 1){
                  //     this.log_name = 'FLO, User Forced To Logout MODE ON: ' + model.user_id + ' USER :: '
                  //     + ' - ' + model.username + ' (' + model.first_name + ' ' + model.surname + ' ' + model.email_address +  ' ) ';

                  //             // insert log
                  //       this.log_data = {
                  //               // log_id: null,
                  //               log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                  //               log_action: 'forced_logout_ON', // automated / updated / created / uploaded / link_created / sent / accessed
                  //               log_type_id: 28, // see datatable system_log_types (12 = subject_attempt)
                  //               // created_by: this.sessionUserId,
                  //               created_by: model.user_id,
                  //               created_date: this.gfunc.today,
                  //               subject_id: model.file_subject_id,
                  //               job_id: model.file_job_id,
                  //               job_reference_number: model.job_reference_number,
                  //               file_number: model.file_number,
                  //               reference_number: model.reference_number,
                  //               subject_number: model.file_subject_number,
                  //               brand_id: model.brand_id,
                  //               user_id: model.user_id,
                            
                  //               created_level: model.created_level, // staff
                  //               brand_type_id: model.brand_type_id,
                  //               subject_com_type_id: model.subject_com_type_id,
                  //               subject_template_doc_id: model.subject_template_doc_id,
                  //               log_name: this.log_name,
                  //             file_id: model.file_id,
                  //             agent_id: null,
                  //             invoice_id: null,
                  //             };



                  //    }else{
                  //     this.log_name = 'FLO, User Forced MODE OFF  ' + model.user_id + ' USER :: '
                  //     + ' - ' + model.username + ' (' + model.first_name + ' ' + model.surname + ' ' + model.email_address +  ' ) ';

                  //         // insert log
                  //         this.log_data = {
                  //           // log_id: null,
                  //           log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                  //           log_action: 'forced_logout_OFF', // automated / updated / created / uploaded / link_created / sent / accessed
                  //           log_type_id: 29, // see datatable system_log_types (12 = subject_attempt)
                  //           // created_by: this.sessionUserId,
                  //           created_by: model.user_id,
                  //           created_date: this.gfunc.today,
                  //           subject_id: model.file_subject_id,
                  //           job_id: model.file_job_id,
                  //           job_reference_number: model.job_reference_number,
                  //           file_number: model.file_number,
                  //           reference_number: model.reference_number,
                  //           subject_number: model.file_subject_number,
                  //           brand_id: model.brand_id,
                  //           user_id: model.user_id,
                        
                  //           created_level: model.created_level, // staff
                  //           brand_type_id: model.brand_type_id,
                  //           subject_com_type_id: model.subject_com_type_id,
                  //           subject_template_doc_id: model.subject_template_doc_id,
                  //           log_name: this.log_name,
                  //         file_id: model.file_id,
                  //         agent_id: null,
                  //         invoice_id: null,
                  //         };


                  //    }


                  //  this.gfunc.createSystemLog(this.log_data);


    //  this.getUserById(this.user_id);
     // Subject to reload the manager component parent.
    // BrandUserManagerComponent.returned.next(false);
       return true;
     },
     error => {
       console.error('Error saving User!');
      //  this.getUserById(this.user_id);
      return console.log(error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
  );
  }

  }
 



  setUserTFAResetGlobal(model, user_id, is_tfa_setup_passed){

    if (confirm('Are you sure you want to reset TFA access for ALL USERS? THIS CANNOT BE UNDONE! ')) {
      this._demoService.setUserTFAResetGlobal(model, user_id, is_tfa_setup_passed) .subscribe(
         data => {
          // console.log(model);
           // this.trace_candidate_update = data;
         this.toastr.success('DONE. ALL Users TFA Status RESET : Updated');
         return true;
        },
        error => {
          console.error('Error saving User!');
         this.toastr.error('there was an error');

         //  this.getUserById(this.user_id);
         return console.log(error);
        }
       // err => console.error(err),
       // () => console.log('done updates')
     );
     }

  }


// update was here for onit but moved for onchange
setUserForceLogoutGlobalSoft(model, user_id, force_logout_soft)  {
  if (confirm('Are you sure you want to FLO soft ALL USERS? ')) {
  this._demoService.setUserForceLogoutGlobalSoft(model, user_id, force_logout_soft) .subscribe(
     data => {
      // console.log(model);
       // this.trace_candidate_update = data;
     this.toastr.success('DONE. ALL Users FLO Status Updated -- SOFT');

                  //    if(force_logout == 1){
                  //     this.log_name = 'FLO, User Forced To Logout MODE ON: ' + model.user_id + ' USER :: '
                  //     + ' - ' + model.username + ' (' + model.first_name + ' ' + model.surname + ' ' + model.email_address +  ' ) ';

                  //             // insert log
                  //       this.log_data = {
                  //               // log_id: null,
                  //               log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                  //               log_action: 'forced_logout_ON', // automated / updated / created / uploaded / link_created / sent / accessed
                  //               log_type_id: 28, // see datatable system_log_types (12 = subject_attempt)
                  //               // created_by: this.sessionUserId,
                  //               created_by: model.user_id,
                  //               created_date: this.gfunc.today,
                  //               subject_id: model.file_subject_id,
                  //               job_id: model.file_job_id,
                  //               job_reference_number: model.job_reference_number,
                  //               file_number: model.file_number,
                  //               reference_number: model.reference_number,
                  //               subject_number: model.file_subject_number,
                  //               brand_id: model.brand_id,
                  //               user_id: model.user_id,
                            
                  //               created_level: model.created_level, // staff
                  //               brand_type_id: model.brand_type_id,
                  //               subject_com_type_id: model.subject_com_type_id,
                  //               subject_template_doc_id: model.subject_template_doc_id,
                  //               log_name: this.log_name,
                  //             file_id: model.file_id,
                  //             agent_id: null,
                  //             invoice_id: null,
                  //             };



                  //    }else{
                  //     this.log_name = 'FLO, User Forced MODE OFF  ' + model.user_id + ' USER :: '
                  //     + ' - ' + model.username + ' (' + model.first_name + ' ' + model.surname + ' ' + model.email_address +  ' ) ';

                  //         // insert log
                  //         this.log_data = {
                  //           // log_id: null,
                  //           log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                  //           log_action: 'forced_logout_OFF', // automated / updated / created / uploaded / link_created / sent / accessed
                  //           log_type_id: 29, // see datatable system_log_types (12 = subject_attempt)
                  //           // created_by: this.sessionUserId,
                  //           created_by: model.user_id,
                  //           created_date: this.gfunc.today,
                  //           subject_id: model.file_subject_id,
                  //           job_id: model.file_job_id,
                  //           job_reference_number: model.job_reference_number,
                  //           file_number: model.file_number,
                  //           reference_number: model.reference_number,
                  //           subject_number: model.file_subject_number,
                  //           brand_id: model.brand_id,
                  //           user_id: model.user_id,
                        
                  //           created_level: model.created_level, // staff
                  //           brand_type_id: model.brand_type_id,
                  //           subject_com_type_id: model.subject_com_type_id,
                  //           subject_template_doc_id: model.subject_template_doc_id,
                  //           log_name: this.log_name,
                  //         file_id: model.file_id,
                  //         agent_id: null,
                  //         invoice_id: null,
                  //         };


                  //    }


                  //  this.gfunc.createSystemLog(this.log_data);


    //  this.getUserById(this.user_id);
     // Subject to reload the manager component parent.
    // BrandUserManagerComponent.returned.next(false);
       return true;
     },
     error => {
      //  console.error('Error saving User!');
      //  this.getUserById(this.user_id);
      return console.log(error.error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
  );
  }

}

// Run log 87 send welcome email single
sendUserWelcomeEmail(model){
  if (confirm('Are you sure you wish to send a welcome email to this user? ')) {
        model.last_insert_id = model.user_id // Send to the new user in automations "brand_report_user or new user"
        model.brand_report_user_id = model.user_id // Send to the new user in automations "brand_report_user or new user"
        // required for new automation type variables to render as report user.
        model.custom_run = 'user_welcome_email';
         model.created_by = this.gfunc.sessionUserId,

        // new trigge and automation so I can run some loops.
        this.gfunc.insertLog_CreateUserSendWelcomeEmail(model)
       
        // this.gfunc.insertLog_CreateUser(model);

}
}
}
